// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#drop-empty{height:calc(100vh - 100px);border:none;position:relative}#drop-empty .dz-message{position:absolute;top:calc(50% - 50px);left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}#drop-documents{border:none;min-height:50px}#drop-documents .dz-message{margin:0}.table-documents .v-data-footer{padding:0!important}.table-documents .v-data-footer__pagination{margin-right:22px}", ""]);
// Exports
module.exports = exports;
